// Generated by scripts/mdi/import-questionnaires.mjs from MDI "BPC-157 09.17.26" (9b9387e8-1c55-4311-bdb7-76eb8072688f). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiBPC157Questions = [
  {
    field: 'mdiBPC157_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiBPC157_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiBPC157_breastfeeding',
    label: 'Are you currently breastfeeding?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '72083502-54f8-4e33-a08e-eb3899bf08c8' }
  },
  {
    field: 'mdiBPC157_wereSorryTreatmentNotMedically',
    label:
      "We're sorry, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '95e0ea1b-c39b-4b4a-a407-82c7837a0344',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiBPC157_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: Please click the attached link to review the consent for your peptide therapy treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the Peptide therapy consent (https://drive.google.com/file/d/1kFJW9tiSZ-QFH9Hrm3bW7U1-P6HOjFtA/view)',
    answer: {
      type: 'text',
      name: 'mdiBPC157_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: 'f0bdc97e-100d-4eff-a810-ef836f39c345' }
  },
  {
    field: 'mdiBPC157_reasonInterestedPeptide',
    label: 'What is the reason you are interested in this peptide?',
    type: 'select',
    educationalSlide: 'Select all that apply',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'tendon_injuries_and_tears',
          value: 'Tendon injuries and tears'
        },
        { key: 'ligament_damage', value: 'Ligament damage' },
        { key: 'muscle_tears_and_strains', value: 'Muscle tears and strains' },
        { key: 'bone_fractures', value: 'Bone fractures' },
        {
          key: 'joint_inflammation_and_arthritis',
          value: 'Joint inflammation and arthritis'
        },
        {
          key: 'gastrointestinal_ulcers_and_inflammatory',
          value: 'Gastrointestinal ulcers and inflammatory bowel disease'
        },
        { key: 'post_surgical_healing', value: 'Post-surgical healing' },
        {
          key: 'nerve_protection_and_repair',
          value: 'Nerve protection and repair'
        },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: '205ca06b-dd3f-4de5-b2ba-53edafc3014a' }
  },
  {
    field: 'mdiBPC157_everUsedPeptideTherapiesPast',
    label: 'Have you ever used peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '5f1fc609-a055-4a72-bbfb-60163f0816b9' }
  },
  {
    field: 'mdiBPC157_peptidesUsedPreviously',
    label: 'What peptides have you used previously?',
    type: 'info',
    answer: { type: 'text', name: 'mdiBPC157_peptidesUsedPreviously', rows: 4 },
    extras: { mdiQuestionId: '631e7a31-bd45-4a75-b5a5-52ac480799da' }
  },
  {
    field: 'mdiBPC157_everReactionSideEffectsPeptide',
    label:
      'Have you ever had a reaction or side effects to peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'b759b282-ad93-4b85-88e9-c747bb985068' }
  },
  {
    field: 'mdiBPC157_reactionSideEffect',
    label: 'What was your reaction or side effect?',
    type: 'info',
    answer: { type: 'text', name: 'mdiBPC157_reactionSideEffect', rows: 4 },
    extras: { mdiQuestionId: 'a6ea7f9c-726e-4028-a4a9-84729c6872a8' }
  },
  {
    field: 'mdiBPC157_diagnosedRedFlagMedicalConditions',
    label:
      'Do you currently have or have you been diagnosed with any of the following red flag medical conditions listed below that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'cancer', value: 'Cancer' },
        {
          key: 'cardiovascular_disease_such_as_heart_att',
          value: 'Cardiovascular disease such as heart attack, stroke, etc'
        },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        { key: 'aneurysm', value: 'Aneurysm' },
        { key: 'thrombosis_blood_clots', value: 'Thrombosis/blood clots' },
        { key: 'psychiatric_illness', value: 'Psychiatric illness' },
        { key: 'suicidal_thoughts', value: 'Suicidal thoughts' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'e9397d1a-d119-4b21-b88e-6627a5e620bc' }
  },
  {
    field: 'mdiBPC157_confirmNotHistoryCancerKidney',
    label:
      'Please confirm you do not have any history of cancer, kidney or liver disease:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_agree_i_do_not_have_any_history_of_can',
          value:
            'I agree, I do NOT have any history of cancer, kidney or liver disease'
        },
        {
          key: 'i_have_been_diagnosed_with_cancer_or_hav',
          value:
            'I HAVE been diagnosed with cancer or have had problems with my kidneys or liver previously'
        }
      ]
    },
    extras: { mdiQuestionId: '99ff14ec-fa75-44a5-b64a-1c52d97afbc6' }
  },
  {
    field: 'mdiBPC157_takeRedFlagMedicationsSubstances',
    label:
      'Do you take any of the following red flag medications or substances that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'alpha_blockers_such_as_razosin_or_doxazo',
          value: 'Alpha blockers (such as razosin or doxazosin)'
        },
        {
          key: 'alpha_agonist_such_as_clonidine',
          value: 'Alpha agonist (such as clonidine)'
        },
        {
          key: 'beta_blockers_such_as_metoprolol_or_prop',
          value: 'Beta blockers  (such as metoprolol or propranolol)'
        },
        {
          key: 'antipsychotic_medications_such_as_halope',
          value:
            'Antipsychotic medications (such as haloperidol or risperidone)'
        },
        {
          key: 'dopamine_agonists_such_as_pramipexole_or',
          value: 'Dopamine agonists (such as pramipexole or bromocriptine)'
        },
        {
          key: 'adhd_medication_such_as_adderall_or_vyva',
          value: 'ADHD medication (such as adderall or vyvanse)'
        },
        {
          key: 'parkinsons_medications_such_as_carbidopa',
          value: 'Parkinson’s medications (such as carbidopa/levodopa)'
        },
        { key: 'nitrate_medications', value: 'Nitrate medications' },
        {
          key: 'pde_5_inhibitors_such_as_sildenafil_or_t',
          value: 'PDE-5 inhibitors (such as sildenafil or tadalafil)'
        },
        { key: 'warfarin', value: 'Warfarin' },
        {
          key: 'blood_thinners_such_as_eliquis_or_xarelt',
          value: 'Blood thinners (such as eliquis or xarelto)'
        },
        {
          key: 'aspirin_clopidogrel_or_any_other_antipla',
          value: 'Aspirin, clopidogrel, or any other antiplatelet medication'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '3119e8cf-77c0-4d35-8183-87011114dec6' }
  },
  {
    field: 'mdiBPC157_allergyBenzylPeroxide',
    label: 'Do you have an allergy to benzyl peroxide?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'd51c4575-f94b-47ca-beb3-e3713309170b' }
  },
  {
    field: 'mdiBPC157_lastTimePersonMedicalEvaluation',
    label: 'When was the last time you had an in-person medical evaluation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_2_years_ago', value: '1-2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: '3cb5c440-e501-4929-a0c9-4199d7be264a' }
  },
  {
    field: 'mdiBPC157_confirmUnderstandContactDoctorQuestions',
    label:
      'Please confirm the following: I understand and will contact my doctor if I have any questions',
    type: 'info',
    subLabel:
      'I understand that this peptide therapy is for use as a subcutaneous injection. I understand I will have to draw up and administer this injection myself. I understand that administering incorrectly or the wrong amount of this peptide therapy may cause serious side effects. I agree that I will reach out to my doctor prior to administering if I have any questions so that I can do it correctly\n\nType your full legal name below:',
    answer: {
      type: 'text',
      name: 'mdiBPC157_confirmUnderstandContactDoctorQuestions'
    },
    extras: { mdiQuestionId: '2f51fb32-61c7-47b6-ac05-4aba7fae29c1' }
  },
  {
    field: 'mdiBPC157_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: { type: 'text', name: 'mdiBPC157_firstMessageDoctor', rows: 4 },
    extras: { mdiQuestionId: '9144b734-514a-4a4d-9662-9d12eb5a3ac1' }
  },
  {
    field: 'mdiBPC157_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiBPC157AnswerField = Partial<
  QuestionAnswerMap<typeof mdiBPC157Questions>
>;

export default mdiBPC157Questions;
